import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslatePipe } from '@ngx-translate/core';
import { trigger, transition, style, animate, query, stagger } from '@angular/animations';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-feature-section',
  standalone: true,
  imports: [CommonModule, TranslateModule, TranslatePipe, RouterModule],
  templateUrl: './feature-section.component.html',
  styleUrl: './feature-section.component.scss',
  host: { id: 'feature-section' },
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('600ms ease-out', style({ opacity: 1 }))
      ])
    ]),
    trigger('staggerFade', [
      transition('* => *', [
        query(':enter', [
          style({ opacity: 0, transform: 'translateY(10px)' }),
          stagger('100ms', [
            animate('500ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class FeatureSectionComponent implements OnInit {
  features: any[] = [];

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    this.loadFeatures();
  }

  private loadFeatures() {
    this.translate.get('home.features-section.features').subscribe((features) => {
      // Ensure features is an array, not a string
      if (Array.isArray(features)) {
        this.features = features;
      }
    });
  }
}
